// import React, { useEffect, useState } from "react";
// import Cookies from "js-cookie";
// import {
//   MdWbSunny, MdWbTwilight, MdNightlight,
//   MdEventBusy, MdOutlineCalendarMonth, MdSchedule,
//   MdChevronLeft, MdChevronRight,
// } from "react-icons/md";
// import doctorService from "../../Services/doctorService";

// const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
// const DAYS   = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

// function fmtDate(str) {
//   if (!str) return "—";
//   const d = new Date(str + "T00:00:00");
//   return `${DAYS[d.getDay()]}, ${MONTHS[d.getMonth()]} ${d.getDate()} ${d.getFullYear()}`;
// }

// function fmtDateShort(d) {
//   return `${DAYS[d.getDay()]}, ${MONTHS[d.getMonth()]} ${d.getDate()}`;
// }

// const SHIFT_CFG = {
//   morning: {
//     label: "Morning",
//     time: "8:00 AM – 2:00 PM",
//     icon: <MdWbSunny size={15} />,
//     pill: "bg-blue-100 text-blue-700",
//     accent: "#3B82F6",
//   },
//   evening: {
//     label: "Evening",
//     time: "2:00 PM – 8:00 PM",
//     icon: <MdWbTwilight size={15} />,
//     pill: "bg-emerald-100 text-emerald-700",
//     accent: "#22A06B",
//   },
//   night: {
//     label: "Night",
//     time: "8:00 PM – 8:00 AM",
//     icon: <MdNightlight size={15} />,
//     pill: "bg-indigo-100 text-indigo-700",
//     accent: "#6366F1",
//   },
// };

// function ShiftPill({ shift }) {
//   const c = SHIFT_CFG[shift] || SHIFT_CFG.morning;
//   return (
//     <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${c.pill}`}>
//       {c.icon} {c.label}
//     </span>
//   );
// }

// const ROWS_PER_PAGE = 10;

// export default function Duties() {
//   const doctor = JSON.parse(Cookies.get("doctor") || "{}");
//   const [duties, setDuties]           = useState([]);
//   const [todayDuty, setTodayDuty]     = useState(null);
//   const [loading, setLoading]         = useState(true);
//   const [filter, setFilter]           = useState("all"); // all | morning | evening | night
//   const [currentPage, setCurrentPage] = useState(1);

//   useEffect(() => {
//     const load = async () => {
//       try {
//         const [d, td] = await Promise.all([
//           doctorService.getDuties(doctor.id),
//           doctorService.getTodayDuty(doctor.id),
//         ]);
//         setDuties(d.duties || []);
//         setTodayDuty(td.duty || null);
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setLoading(false);
//       }
//     };
//     load();
//   }, [doctor.id]);

//   const filtered = filter === "all" ? duties : duties.filter((d) => d.shift === filter);

//   // Reset to page 1 whenever filter or data changes
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [filter, duties]);

//   // ---- Pagination math ----
//   const totalPages = Math.max(1, Math.ceil(filtered.length / ROWS_PER_PAGE));
//   const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
//   const paginatedData = filtered.slice(startIndex, startIndex + ROWS_PER_PAGE);

//   const goToPage = (page) => {
//     if (page < 1 || page > totalPages) return;
//     setCurrentPage(page);
//   };

//   const getPageNumbers = () => {
//     const pages = [];
//     const maxVisible = 5;
//     let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
//     let end = Math.min(totalPages, start + maxVisible - 1);
//     if (end - start + 1 < maxVisible) {
//       start = Math.max(1, end - maxVisible + 1);
//     }
//     for (let i = start; i <= end; i++) pages.push(i);
//     return pages;
//   };
//   const pageNumbers = getPageNumbers();

//   const counts = {
//     morning: duties.filter((d) => d.shift === "morning").length,
//     evening: duties.filter((d) => d.shift === "evening").length,
//     night:   duties.filter((d) => d.shift === "night").length,
//   };

//   const now = new Date();
//   const todayStr = now.toISOString().slice(0, 10);
//   const todayCfg = todayDuty ? (SHIFT_CFG[todayDuty.shift] || SHIFT_CFG.morning) : null;

//   return (
//     <div>
//       <div className="mb-5">
//         <h1 className="text-gray-800 text-xl font-semibold">My Duties</h1>
//         <p className="text-gray-400 text-sm mt-0.5">Your duty  and shift schedule</p>
//       </div>

//       {/* ───────── Today's Shift hero ───────── */}
//       {todayDuty ? (
//         <div className="relative rounded-2xl p-6 mb-5 overflow-hidden border border-gray-200 shadow-sm">
//           <div className="pointer-events-none absolute -top-16 -right-16 w-56 h-56 rounded-full opacity-20 blur-3xl" />

//           <div className="relative flex items-start justify-between gap-4">
//             <div>
//               <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-400">
//                 {fmtDateShort(now)}
//               </p>

//               <div className="flex items-center gap-2 mt-3">
//                 <span
//                   className="inline-flex items-center justify-center w-8 h-8 rounded-full"
//                   style={{ backgroundColor: `${todayCfg.accent}33`, color: todayCfg.accent }}
//                 >
//                   {React.cloneElement(todayCfg.icon, { size: 17 })}
//                 </span>
//                 <span className="text-gary-700 text-[15px] font-medium">
//                   {todayCfg.label} Shift
//                 </span>
//               </div>

//               <p className="text-gray-700 text-[32px] font-semibold tracking-tight mt-3 leading-none">
//                 {todayCfg.time}
//               </p>

//               {todayDuty.role_name && (
//                 <p className="text-gray-500 text-xs mt-2">{todayDuty.role_name}</p>
//               )}
//               {todayDuty.notes && (
//                 <p className="text-gray-700 text-xs mt-1">{todayDuty.notes}</p>
//               )}
//             </div>

//             <span className="shrink-0 text-[10px] font-semibold uppercase tracking-wider bg-gray-100 text-gray-700 px-2.5 py-1 rounded-full border border-gray-200">
//               On duty today
//             </span>
//           </div>
//         </div>
//       ) : (
//         <div className="rounded-2xl p-6 mb-5 border border-dashed border-gray-200 bg-gray-50/60">
//           <div className="flex items-center gap-3">
//             <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-gray-100 text-gray-400">
//               <MdOutlineCalendarMonth size={18} />
//             </span>
//             <div>
//               <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-400">
//                 {fmtDateShort(now)}
//               </p>
//               <p className="text-gray-500 text-sm mt-0.5">No duty assigned for today</p>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Table */}
//       <div className="bg-white border border-gray-100 rounded-xl shadow-sm overflow-hidden">
//         {/* Filter bar */}
//         <div className="flex flex-wrap items-center gap-2 px-5 py-4 border-b border-gray-100">
//           <span className="text-xs text-gray-400 mr-1">Filter by shift:</span>
//           {[
//             { key: "all",     label: `All (${duties.length})` },
//             { key: "morning", label: `Morning (${counts.morning})` },
//             { key: "evening", label: `Evening (${counts.evening})` },
//             { key: "night",   label: `Night (${counts.night})` },
//           ].map((f) => (
//             <button
//               key={f.key}
//               onClick={() => setFilter(f.key)}
//               className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-all ${
//                 filter === f.key
//                   ? "bg-[#225187] text-white border-[#1a2e4a]"
//                   : "border-gray-200 text-gray-500 hover:border-gray-300"
//               }`}
//             >
//               {f.label}
//             </button>
//           ))}
//         </div>

//         {loading ? (
//           <div className="py-16 text-center text-gray-400 text-sm">Loading...</div>
//         ) : filtered.length === 0 ? (
//           <div className="py-16 text-center">
//             <MdEventBusy size={40} className="text-gray-200 mx-auto mb-2" />
//             <p className="text-gray-400 text-sm">No duties found</p>
//           </div>
//         ) : (
//           <>
//             <div className="overflow-x-auto">
//               <table className="w-full text-sm">
//                 <thead>
//                   <tr className="bg-[#225187]">
//                     {["SR","Duty Date","Shift","Time","Notes","Status"].map((h) => (
//                       <th key={h} className="text-left text-white/80 text-xs font-medium px-4 py-3 whitespace-nowrap">
//                         {h}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {paginatedData.map((d, i) => {
//                     const isToday = d.duty_date?.slice(0, 10) === todayStr;
//                     const cfg = SHIFT_CFG[d.shift] || SHIFT_CFG.morning;
//                     return (
//                       <tr
//                         key={d.id}
//                         className={`border-b border-gray-50 transition-colors ${isToday ? "bg-blue-50/50" : "hover:bg-gray-50"}`}
//                       >
//                         <td className="px-4 py-3 text-gray-400 text-xs">{startIndex + i + 1}</td>
//                         <td className="px-4 py-3">
//                           <div className="flex items-center gap-1.5">
//                             <span className="text-gray-700 text-xs font-medium whitespace-nowrap">{fmtDate(d.duty_date)}</span>
//                             {isToday && (
//                               <span className="text-[10px] bg-blue-600 text-white px-1.5 py-0.5 rounded-full">Today</span>
//                             )}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3">
//                           <ShiftPill shift={d.shift} />
//                         </td>
//                         <td className="px-4 py-3 text-gray-500 text-xs whitespace-nowrap">{cfg.time}</td>
//                         <td className="px-4 py-3 text-gray-500 text-xs max-w-[200px] truncate">{d.notes || "—"}</td>
//                         <td className="px-4 py-3">
//                           {isToday ? (
//                             <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full">Active</span>
//                           ) : new Date(d.duty_date) < new Date() ? (
//                             <span className="text-xs bg-gray-100 text-gray-500 px-2 py-0.5 rounded-full">Completed</span>
//                           ) : (
//                             <span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">Upcoming</span>
//                           )}
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination bar */}
//             <div className="flex flex-wrap items-center justify-between gap-3 px-5 py-3 border-t border-gray-100">
//               <p className="text-xs text-gray-400">
//                 Showing {startIndex + 1}–{Math.min(startIndex + ROWS_PER_PAGE, filtered.length)} of {filtered.length}
//               </p>
//               <div className="flex items-center gap-1">
//                 <button
//                   onClick={() => goToPage(currentPage - 1)}
//                   disabled={currentPage === 1}
//                   className="w-7 h-7 flex items-center justify-center rounded-md text-gray-400 hover:bg-gray-100 disabled:opacity-40 disabled:hover:bg-transparent transition-colors"
//                 >
//                   <MdChevronLeft size={16} />
//                 </button>

//                 {pageNumbers[0] > 1 && (
//                   <>
//                     <button
//                       onClick={() => goToPage(1)}
//                       className="w-7 h-7 flex items-center justify-center rounded-md text-xs text-gray-500 hover:bg-gray-100 transition-colors"
//                     >
//                       1
//                     </button>
//                     <span className="text-gray-300 text-xs px-0.5">...</span>
//                   </>
//                 )}

//                 {pageNumbers.map((page) => (
//                   <button
//                     key={page}
//                     onClick={() => goToPage(page)}
//                     className={`w-7 h-7 flex items-center justify-center rounded-md text-xs font-medium transition-colors ${
//                       currentPage === page
//                         ? "bg-[#225187] text-white"
//                         : "text-gray-500 hover:bg-gray-100"
//                     }`}
//                   >
//                     {page}
//                   </button>
//                 ))}

//                 {pageNumbers[pageNumbers.length - 1] < totalPages && (
//                   <>
//                     <span className="text-gray-300 text-xs px-0.5">...</span>
//                     <button
//                       onClick={() => goToPage(totalPages)}
//                       className="w-7 h-7 flex items-center justify-center rounded-md text-xs text-gray-500 hover:bg-gray-100 transition-colors"
//                     >
//                       {totalPages}
//                     </button>
//                   </>
//                 )}

//                 <button
//                   onClick={() => goToPage(currentPage + 1)}
//                   disabled={currentPage === totalPages}
//                   className="w-7 h-7 flex items-center justify-center rounded-md text-gray-400 hover:bg-gray-100 disabled:opacity-40 disabled:hover:bg-transparent transition-colors"
//                 >
//                   <MdChevronRight size={16} />
//                 </button>
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import {
  MdWbSunny, MdWbTwilight, MdNightlight,
  MdEventBusy, MdOutlineCalendarMonth,
  MdChevronLeft, MdChevronRight,
} from "react-icons/md";
import doctorService from "../../Services/doctorService";

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const DAYS   = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

function fmtDate(str) {
  if (!str) return "—";
  const d = new Date(str + "T00:00:00");
  return `${DAYS[d.getDay()]}, ${MONTHS[d.getMonth()]} ${d.getDate()} ${d.getFullYear()}`;
}

function fmtDateShort(d) {
  return `${DAYS[d.getDay()]}, ${MONTHS[d.getMonth()]} ${d.getDate()}`;
}

function formatTime(t) {
  if (!t) return "—";
  const [h, m] = t.split(":");
  const hour = parseInt(h, 10);
  const ampm = hour >= 12 ? "PM" : "AM";
  const displayHour = hour % 12 === 0 ? 12 : hour % 12;
  return `${displayHour}:${m} ${ampm}`;
}

function getShiftTime(duty, cfg) {
  if (duty?.start_time && duty?.end_time) {
    return `${formatTime(duty.start_time)} – ${formatTime(duty.end_time)}`;
  }
  return cfg.time;
}

const SHIFT_CFG = {
  morning: {
    label: "Morning",
    time: "8:00 AM – 2:00 PM",
    icon: <MdWbSunny size={15} />,
    pill: "bg-blue-100 text-blue-700",
    accent: "#3B82F6",
  },
  evening: {
    label: "Evening",
    time: "2:00 PM – 8:00 PM",
    icon: <MdWbTwilight size={15} />,
    pill: "bg-emerald-100 text-emerald-700",
    accent: "#22A06B",
  },
  night: {
    label: "Night",
    time: "8:00 PM – 8:00 AM",
    icon: <MdNightlight size={15} />,
    pill: "bg-indigo-100 text-indigo-700",
    accent: "#6366F1",
  },
};

function ShiftPill({ shift }) {
  const c = SHIFT_CFG[shift] || SHIFT_CFG.morning;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${c.pill}`}>
      {c.icon} {c.label}
    </span>
  );
}

const ROWS_PER_PAGE = 10;

export default function Duties() {
  const doctor = JSON.parse(Cookies.get("doctor") || "{}");
  const [duties, setDuties]           = useState([]);
  const [todayDuty, setTodayDuty]     = useState(null);
  const [loading, setLoading]         = useState(true);
  const [filter, setFilter]           = useState("all");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const load = async () => {
      try {
        const [d, td] = await Promise.all([
          doctorService.getDuties(doctor.id),
          doctorService.getTodayDuty(doctor.id),
        ]);
        setDuties(d.duties || []);
        setTodayDuty(td.duty || null);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [doctor.id]);

  const filtered = filter === "all" ? duties : duties.filter((d) => d.shift === filter);

  useEffect(() => {
    setCurrentPage(1);
  }, [filter, duties]);

  const totalPages  = Math.max(1, Math.ceil(filtered.length / ROWS_PER_PAGE));
  const startIndex  = (currentPage - 1) * ROWS_PER_PAGE;
  const paginatedData = filtered.slice(startIndex, startIndex + ROWS_PER_PAGE);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let end   = Math.min(totalPages, start + maxVisible - 1);
    if (end - start + 1 < maxVisible) start = Math.max(1, end - maxVisible + 1);
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  };
  const pageNumbers = getPageNumbers();

  const counts = {
    morning: duties.filter((d) => d.shift === "morning").length,
    evening: duties.filter((d) => d.shift === "evening").length,
    night:   duties.filter((d) => d.shift === "night").length,
  };

  const now      = new Date();
  const todayStr = now.toISOString().slice(0, 10);
  const todayCfg = todayDuty ? (SHIFT_CFG[todayDuty.shift] || SHIFT_CFG.morning) : null;

  return (
    <div>
      <div className="mb-5">
        <h1 className="text-gray-800 text-xl font-semibold">My Duties</h1>
        <p className="text-gray-400 text-sm mt-0.5">Your duty and shift schedule</p>
      </div>

      {/* Today's Shift hero */}
      {todayDuty ? (
        <div className="relative rounded-2xl p-6 mb-5 overflow-hidden border border-gray-200 shadow-sm">
          <div className="pointer-events-none absolute -top-16 -right-16 w-56 h-56 rounded-full opacity-20 blur-3xl" />
          <div className="relative flex items-start justify-between gap-4">
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-400">
                {fmtDateShort(now)}
              </p>
              <div className="flex items-center gap-2 mt-3">
                <span
                  className="inline-flex items-center justify-center w-8 h-8 rounded-full"
                  style={{ backgroundColor: `${todayCfg.accent}33`, color: todayCfg.accent }}
                >
                  {React.cloneElement(todayCfg.icon, { size: 17 })}
                </span>
                <span className="text-gray-700 text-[15px] font-medium">
                  {todayCfg.label} Shift
                </span>
              </div>

              {/* ✅ Shows actual DB times */}
              <p className="text-gray-700 text-[32px] font-semibold tracking-tight mt-3 leading-none">
                {getShiftTime(todayDuty, todayCfg)}
              </p>

              {todayDuty.role_name && (
                <p className="text-gray-500 text-xs mt-2">{todayDuty.role_name}</p>
              )}
              {todayDuty.notes && (
                <p className="text-gray-700 text-xs mt-1">{todayDuty.notes}</p>
              )}
            </div>
            <span className="shrink-0 text-[10px] font-semibold uppercase tracking-wider bg-gray-100 text-gray-700 px-2.5 py-1 rounded-full border border-gray-200">
              On duty today
            </span>
          </div>
        </div>
      ) : (
        <div className="rounded-2xl p-6 mb-5 border border-dashed border-gray-200 bg-gray-50/60">
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-gray-100 text-gray-400">
              <MdOutlineCalendarMonth size={18} />
            </span>
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-400">
                {fmtDateShort(now)}
              </p>
              <p className="text-gray-500 text-sm mt-0.5">No duty assigned for today</p>
            </div>
          </div>
        </div>
      )}

      {/* Table */}
      <div className="bg-white border border-gray-100 rounded-xl shadow-sm overflow-hidden">
        {/* Filter bar */}
        <div className="flex flex-wrap items-center gap-2 px-5 py-4 border-b border-gray-100">
          <span className="text-xs text-gray-400 mr-1">Filter by shift:</span>
          {[
            { key: "all",     label: `All (${duties.length})` },
            { key: "morning", label: `Morning (${counts.morning})` },
            { key: "evening", label: `Evening (${counts.evening})` },
            { key: "night",   label: `Night (${counts.night})` },
          ].map((f) => (
            <button
              key={f.key}
              onClick={() => setFilter(f.key)}
              className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-all ${
                filter === f.key
                  ? "bg-[#225187] text-white border-[#1a2e4a]"
                  : "border-gray-200 text-gray-500 hover:border-gray-300"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="py-16 text-center text-gray-400 text-sm">Loading...</div>
        ) : filtered.length === 0 ? (
          <div className="py-16 text-center">
            <MdEventBusy size={40} className="text-gray-200 mx-auto mb-2" />
            <p className="text-gray-400 text-sm">No duties found</p>
          </div>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-[#225187]">
                    {["SR","Duty Date","Shift","Time","Notes","Status"].map((h) => (
                      <th key={h} className="text-left text-white/80 text-xs font-medium px-4 py-3 whitespace-nowrap">
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.map((d, i) => {
                    const isToday = d.duty_date?.slice(0, 10) === todayStr;
                    const cfg     = SHIFT_CFG[d.shift] || SHIFT_CFG.morning;
                    return (
                      <tr
                        key={d.id}
                        className={`border-b border-gray-50 transition-colors ${isToday ? "bg-blue-50/50" : "hover:bg-gray-50"}`}
                      >
                        <td className="px-4 py-3 text-gray-400 text-xs">{startIndex + i + 1}</td>
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-1.5">
                            <span className="text-gray-700 text-xs font-medium whitespace-nowrap">{fmtDate(d.duty_date)}</span>
                            {isToday && (
                              <span className="text-[10px] bg-blue-600 text-white px-1.5 py-0.5 rounded-full">Today</span>
                            )}
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <ShiftPill shift={d.shift} />
                        </td>
                        {/* ✅ Shows actual DB times */}
                        <td className="px-4 py-3 text-gray-500 text-xs whitespace-nowrap">
                          {getShiftTime(d, cfg)}
                        </td>
                        <td className="px-4 py-3 text-gray-500 text-xs max-w-[200px] truncate">{d.notes || "—"}</td>
                        <td className="px-4 py-3">
                          {isToday ? (
                            <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full">Active</span>
                          ) : new Date(d.duty_date) < new Date() ? (
                            <span className="text-xs bg-gray-100 text-gray-500 px-2 py-0.5 rounded-full">Completed</span>
                          ) : (
                            <span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">Upcoming</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="flex flex-wrap items-center justify-between gap-3 px-5 py-3 border-t border-gray-100">
              <p className="text-xs text-gray-400">
                Showing {startIndex + 1}–{Math.min(startIndex + ROWS_PER_PAGE, filtered.length)} of {filtered.length}
              </p>
              <div className="flex items-center gap-1">
                <button
                  onClick={() => goToPage(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="w-7 h-7 flex items-center justify-center rounded-md text-gray-400 hover:bg-gray-100 disabled:opacity-40 disabled:hover:bg-transparent transition-colors"
                >
                  <MdChevronLeft size={16} />
                </button>

                {pageNumbers[0] > 1 && (
                  <>
                    <button onClick={() => goToPage(1)} className="w-7 h-7 flex items-center justify-center rounded-md text-xs text-gray-500 hover:bg-gray-100 transition-colors">1</button>
                    <span className="text-gray-300 text-xs px-0.5">...</span>
                  </>
                )}

                {pageNumbers.map((page) => (
                  <button
                    key={page}
                    onClick={() => goToPage(page)}
                    className={`w-7 h-7 flex items-center justify-center rounded-md text-xs font-medium transition-colors ${
                      currentPage === page ? "bg-[#225187] text-white" : "text-gray-500 hover:bg-gray-100"
                    }`}
                  >
                    {page}
                  </button>
                ))}

                {pageNumbers[pageNumbers.length - 1] < totalPages && (
                  <>
                    <span className="text-gray-300 text-xs px-0.5">...</span>
                    <button onClick={() => goToPage(totalPages)} className="w-7 h-7 flex items-center justify-center rounded-md text-xs text-gray-500 hover:bg-gray-100 transition-colors">{totalPages}</button>
                  </>
                )}

                <button
                  onClick={() => goToPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="w-7 h-7 flex items-center justify-center rounded-md text-gray-400 hover:bg-gray-100 disabled:opacity-40 disabled:hover:bg-transparent transition-colors"
                >
                  <MdChevronRight size={16} />
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}